/**
 * 지식베이스 열람 (/adm/dev/docs) — .ai 문서 트리·본문·목차·검색·점검
 * ($j.Pages.Admin.AiDocs / body data-page-name="AiDocs")
 *
 * 화면 상태(curDoc·showRaw·lastQ·folded)는 이 모듈 안에만 있다 — window 에 내놓지 않는다.
 */
let curDoc  = null;   // 지금 열어 둔 문서 (원문·복사가 참조)
let showRaw = false;
let lastQ   = '';     // 검색으로 들어온 문서면 본문에 그 말을 칠해 준다

export default class AiDocs {
    initialize() {
        loadTree();

        $('#filter').on('input', applyFilter);
        $('#q').on('keydown', function (e) { if (e.key === 'Enter') runSearch($(this).val()); });
        $('#btnAudit').on('click', runAudit);
        $('#btnRaw').on('click', function () { showRaw = !showRaw; if (curDoc) paintDoc(curDoc); });
        $('#btnCopy').on('click', onClickCopy);

        $(document).on('click', '.aid-dir-head', function () { onToggleDir($(this)); });
        $(document).on('click', '.aid-item', function () { openDoc($(this).data('rel')); });
        $(document).on('click', '.aid-link-item', function () { openDoc($(this).data('rel')); });
        $(document).on('click', '.aid-hit-head', function () { openDoc($(this).data('rel')); });
        // 문서 안에서 다른 문서로 — 페이지를 떠나지 않고 이어서 읽는다
        $(document).on('click', '.aid-xlink', function () { openDoc($(this).data('rel'), $(this).data('anchor')); });
        $(document).on('click', '.aid-toc a', function (e) {
            e.preventDefault();
            const el = document.getElementById($(this).data('id'));
            if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });

        // 뒤로가기로 이전 문서 — 문서를 타고 들어갔다가 되돌아 나오는 동선이 잦다
        window.addEventListener('hashchange', function () {
            const rel = decodeURIComponent(location.hash.replace(/^#/, ''));
            if (rel && (!curDoc || curDoc.rel !== rel)) openDoc(rel, '', true);
        });
    }
}


/* ── 트리 ────────────────────────────────────── */

// 접어 둔 폴더 (.ai/state-conventions.md §2 형식). 관리자 개인 브라우저 설정이라 서버에 안 남긴다.
const SK_FOLD = 'adm:aidocs:folded';
let folded = {};

function loadTree() {
    folded = $j.Common.Store.local.getJSON(SK_FOLD, {}) || {};

    $.post('/adm/ajax/dev/docs/tree', {}, function (res) {
        if (!res.result) { $('#tree').html('<span class="aid-muted">' + res.message + '</span>'); return; }

        $('#tree').html(renderNodes(res.tree));
        $('#summary').text(`문서 ${res.summary.docs} · 링크 ${res.summary.links}`
            + (res.summary.dead ? ` · 깨진링크 ${res.summary.dead}` : ''));

        const start = decodeURIComponent(location.hash.replace(/^#/, '')) || 'README.md';
        openDoc(start, '', true);
    });
}

function renderNodes(nodes, depth) {
    depth = depth || 0;
    return nodes.map(function (n) {
        if (n.type !== 'dir') return fileRow(n);

        const open = !folded[n.path];
        // 1단은 훑을 때 먼저 걸리는 기준선이라 띠로 세운다 (안쪽 폴더는 조용하게)
        return `<div class="aid-dir${depth === 0 ? ' is-top' : ''}" data-path="${esc(n.path)}">
                    <div class="aid-dir-head">
                        <i class="fas fa-caret-${open ? 'down' : 'right'}"></i>
                        <span class="aid-dir-name">${esc(n.label)}</span>
                        <span class="aid-dir-path">${esc(n.dirname)}</span>
                        <span class="aid-dir-count">${n.count}</span>
                    </div>
                    <div class="aid-dir-body${open ? '' : ' is-folded'}">${renderNodes(n.children, depth + 1)}</div>
                </div>`;
    }).join('');
}

/**
 * 목록은 제목 한 줄이다. 파일명·역링크·갱신일은 문서를 **고르는** 데 안 쓰이고 훑는 눈만 잡아먹는다 —
 * 전부 보기화면(머리글·우측 패널)에 있다. 예외는 깨진 링크 하나 — 문제 있을 때만 뜨므로 평소엔 없다.
 * (걸러내기는 화면에 없는 파일명·경로까지 계속 본다 — data-search)
 */
function fileRow(f) {
    const dead = f.dead ? ' <span class="aid-warn" title="이 문서 안의 깨진 링크 수">깨짐 ' + f.dead + '</span>' : '';

    return `<div class="aid-item" data-rel="${esc(f.rel)}" data-search="${esc((f.title + ' ' + f.rel).toLowerCase())}">
                <span class="aid-item-title">${esc(f.title)}${dead}</span>
            </div>`;
}

function onToggleDir($head) {
    const $dir = $head.closest('.aid-dir');
    const path = $dir.data('path');
    const open = $dir.children('.aid-dir-body').is(':visible');

    $dir.children('.aid-dir-body').slideToggle(120);
    $head.find('i').attr('class', 'fas fa-caret-' + (open ? 'right' : 'down'));

    if (open) folded[path] = 1; else delete folded[path];
    $j.Common.Store.local.setJSON(SK_FOLD, folded);
}

/** 걸러내는 동안은 폴더를 전부 펴고, 남은 문서가 없는 폴더는 통째로 감춘다 */
function applyFilter() {
    const q = $('#filter').val().trim().toLowerCase();

    $('.aid-item').each(function () {
        $(this).toggle(!q || ($(this).data('search') || '').indexOf(q) !== -1);
    });

    if (!q) { $('.aid-dir').show(); restoreFold(); return; }

    $('.aid-dir').show();
    $('.aid-dir-body').show();
    $('.aid-dir-head i').attr('class', 'fas fa-caret-down');
    // 안쪽 폴더부터 판정해야 한다 — 부모가 먼저 숨으면 자식의 :visible 이 전부 false 가 된다
    $($('.aid-dir').get().reverse()).each(function () {
        $(this).toggle($(this).find('.aid-item:visible').length > 0);
    });
}

function restoreFold() {
    $('.aid-dir').each(function () {
        const open = !folded[$(this).data('path')];
        $(this).children('.aid-dir-body').toggle(open);
        $(this).children('.aid-dir-head').find('i').attr('class', 'fas fa-caret-' + (open ? 'down' : 'right'));
    });
}

/* ── 문서 ────────────────────────────────────── */

function openDoc(rel, anchor, keepHash) {
    if (!rel) return;

    $.post('/adm/ajax/dev/docs/doc', { rel: rel }, function (res) {
        if (!res.result) { $('#docBody').html('<span class="aid-muted">' + res.message + '</span>'); return; }

        curDoc = res.doc;
        if (!keepHash || location.hash !== '#' + rel) location.hash = rel;

        $('.aid-item').removeClass('is-active');
        const $item = $('.aid-item[data-rel="' + cssEsc(res.doc.rel) + '"]').addClass('is-active');
        if ($item.length) { openAncestors($item); scrollIntoNav($item); }

        paintDoc(res.doc);
        paintSide(res.doc);

        if (anchor) {
            // 원본 앵커(#헤딩)는 우리가 붙인 id 와 다르다 — 글자로 찾아 간다
            const want = decodeURIComponent(anchor.replace(/^#/, '')).replace(/-/g, ' ').toLowerCase();
            const hit = (res.doc.toc || []).find(t => t.text.toLowerCase().replace(/\s+/g, ' ').indexOf(want) !== -1);
            const el = hit && document.getElementById(hit.id);
            if (el) el.scrollIntoView({ block: 'start' });
        } else {
            $('#docBody').scrollTop(0);
        }
    });
}

function paintDoc(doc) {
    $('#docHead').prop('hidden', false);
    $('#docTitle').text(doc.title);

    const stale = doc.stale ? ' <span class="aid-stale">· 오래됨</span>' : '';
    $('#docSub').html(`<code>.ai/${esc(doc.rel)}</code>`
        + `<span>${esc(doc.group)}${doc.layer ? ' · ' + esc(doc.layer) + '층' : ''}</span>`
        + `<span>${doc.lines.toLocaleString()}줄 · ${Math.round(doc.size / 1024)}KB</span>`
        + `<span>갱신 ${doc.date}${stale}</span>`
        + (doc.dead.length ? `<span class="aid-stale">깨진 링크 ${doc.dead.length}: ${esc(doc.dead.join(', '))}</span>` : ''));

    $('#btnRaw').toggleClass('active', showRaw);

    if (showRaw || !doc.isMd) {
        $('#docBody').html('<pre class="aid-raw"></pre>');
        $('#docBody .aid-raw').text(doc.raw);
        return;
    }

    $('#docBody').html('<div class="aid-md">' + doc.html + '</div>');
    if (lastQ) highlight($('#docBody .aid-md')[0], lastQ);
}

function paintSide(doc) {
    $('#toc').html((doc.toc || []).length
        ? doc.toc.map(t => `<a href="#" class="lv${t.level}" data-id="${t.id}">${esc(t.text)}</a>`).join('')
        : '<span class="aid-muted">-</span>');

    $('#outbound').html(linkList(doc.outbound));
    $('#inbound').html(linkList(doc.inbound));
}

function linkList(items) {
    if (!items || !items.length) return '<span class="aid-muted">없음</span>';
    return items.map(i => `<span class="aid-link-item" data-rel="${esc(i.rel)}">${esc(i.title)}<br><small>${esc(i.rel)}</small></span>`).join('');
}

/* ── 검색 ────────────────────────────────────── */

function runSearch(q) {
    q = (q || '').trim();
    lastQ = q;
    if (q.length < 2) return;

    $.post('/adm/ajax/dev/docs/search', { q: q }, function (res) {
        $('#docHead').prop('hidden', false);
        $('#docTitle').text('검색: ' + q);
        $('#docSub').html(`<span>${res.hits.length}개 문서 · ${res.total}줄 일치</span>`);

        if (!res.hits.length) { $('#docBody').html('<span class="aid-muted">일치하는 줄이 없습니다.</span>'); return; }

        const html = res.hits.map(function (h) {
            const lines = h.lines.map(l => `<div class="aid-hit-line"><b>${l.line}</b>${hl(esc(l.text), q)}</div>`).join('');
            return `<div class="aid-hit">
                        <div class="aid-hit-head" data-rel="${esc(h.rel)}">${esc(h.title)}
                            <small class="aid-muted">— ${esc(h.group)} / ${esc(h.rel)} · ${h.count}줄</small>
                        </div>${lines}
                    </div>`;
        }).join('');

        $('#docBody').html(html).scrollTop(0);
    });
}

/* ── 점검 ────────────────────────────────────── */

function runAudit() {
    $.post('/adm/ajax/dev/docs/audit', {}, function (res) {
        $('#docHead').prop('hidden', false);
        $('#docTitle').text('지식베이스 점검');
        $('#docSub').html('<span>기준은 하나 — 6개월 뒤에도 그대로 참인 문장만 여기 둔다</span>');

        const link = (rel, label) => `<a data-rel="${esc(rel)}" class="aid-link-item d-inline">${esc(label || rel)}</a>`;

        const dated = rows(res.dated, d =>
            `${link(d.rel, d.title)} <span class="aid-muted ml-2">${esc(d.rel)}</span>`
            + `<span class="aid-stale ml-2">${esc(d.kinds.join(' · '))}</span>`
            + `<span class="aid-muted ml-2">${esc(d.marks.join(', '))}</span>`);

        const paths = rows(res.badPaths, b =>
            `${link(b.rel, b.rel)}`
            + b.items.map(it => `<div class="aid-hit-line"><b>${it.line}</b>`
                + `<span class="aid-stale">${esc(it.path)}</span> — ${esc(it.text)}</div>`).join(''));

        const dead = rows(res.dead, d =>
            `${link(d.rel, d.rel)} <span class="aid-stale ml-2">${esc(d.targets.join(', '))}</span>`);

        const orphans = rows(res.orphans, o =>
            `${link(o.rel, o.title)} <span class="aid-muted ml-2">${esc(o.rel)}</span>`);

        const stale = rows(res.stale, s2 =>
            `<span class="aid-stale">${s2.date}</span> ${link(s2.rel, s2.title)}`);

        const narrative = rows(res.narrative, d =>
            `${link(d.rel, d.rel)} <span class="aid-stale ml-2">${d.items.length}건</span>`
            + d.items.map(it => `<div class="aid-hit-line"><b>${it.line}</b>`
                + `<span class="aid-stale">${esc(it.kind)}</span> — ${esc(it.text)}</div>`).join(''));

        const dup = rows(res.dup, d =>
            `${link(d.rel, d.rel)} <span class="aid-stale ml-2">${d.items.length}건</span>`
            + d.items.map(it => `<div class="aid-hit-line"><b>${it.line}</b>`
                + `<span>${esc(it.text)}</span></div>`).join(''));

        const bal = balanceTable(res.balance);
        const balN = res.balance.rows.filter(r => r.flag).length;

        $('#docBody').html(
              sect('분량 밸런스', balN, '문서 분량이 도메인의 무게를 따라가는가. 갱신 트리거가 "그 코드를 건드릴 때"라 분량이 중요도가 아니라 최근 작업량을 따라가기 쉽다.', bal)
            + sect('경위 서술', res.narrative.length, '"왜 이렇게 고쳤나"가 새어든 줄. 증상·원인·경위는 커밋 메시지가 갖는다. 일부러 남긴 사고 기록도 잡히므로 후보로만 본다.', narrative)
            + sect('코드주석 복제', res.dup.length, '소스 주석과 똑같은 문장. 표·목록이 겹치면 반드시 어긋나니 가리키기로 바꾼다. 설명 한 줄이 겹치는 것은 각자 자립하는 편이 나을 때도 있어 후보로만 본다.', dup)
            + sect('시점물 의심', res.dated.length, '그때 한정 기록이 지식베이스에 섞였다. 계획·전달노트·인수인계는 원장이나 커밋으로 간다.', dated)
            + sect('없는 경로', res.badPaths.length, '문서가 지목한 소스가 저장소에 없다. 코드가 옮겨가면 링크보다 먼저 여기가 어긋난다.', paths)
            + sect('깨진 링크', res.dead.length, '파일을 옮기거나 지웠는데 가리키는 쪽을 안 고친 자리.', dead)
            + sect('고아 문서', res.orphans.length, '아무 문서도 가리키지 않는다 — 목차를 안 보면 존재를 모른다.', orphans)
            + sect(`오래된 문서`, res.stale.length, `마지막으로 손댄 지 ${res.days}일이 넘었다. 그 사이 코드가 바뀌었는지 대조할 후보.`, stale)
        ).scrollTop(0);
    });
}

/**
 * 분량 밸런스 표 — 비율 높은 순. '코드줄'은 그 문서가 본문에서 지목한 소스의 줄 수이고,
 * 한 소스는 그것을 가장 여러 번 언급한 문서 하나에만 귀속된다(남의 코드로 사거리를 부풀리지 않게).
 */
function balanceTable(b) {
    if (!b || !b.rows || !b.rows.length) return '<div class="aid-muted">없음</div>';

    const head = `<div class="aid-audit-row aid-muted">중앙값 ${b.median}% — 이 배수를 크게 벗어난 문서만 짚는다</div>`;
    return head + b.rows.map(r => {
        const ratio = r.ratio === null ? '—' : r.ratio + '%';
        const flag  = r.flag ? `<span class="aid-stale ml-2">${esc(r.flag)}</span>` : '';
        return `<div class="aid-audit-row"><a data-rel="${esc(r.rel)}" class="aid-link-item d-inline">${esc(r.rel)}</a>`
             + `<span class="aid-muted ml-2">문서 ${r.doc}줄 · 코드 ${r.reach}줄</span>`
             + `<span class="ml-2"><b>${ratio}</b></span>${flag}</div>`;
    }).join('');
}

function sect(title, n, desc, body) {
    return `<div class="aid-audit-sect">
                <h4>${esc(title)} <span class="${n ? 'aid-stale' : 'aid-muted'}">${n}</span></h4>
                <div class="desc">${esc(desc)}</div>${body}
            </div>`;
}

function rows(list, fn) {
    if (!list || !list.length) return '<div class="aid-muted">없음</div>';
    return list.map(x => `<div class="aid-audit-row">${fn(x)}</div>`).join('');
}

/* ── 잡동사니 ────────────────────────────────── */

function onClickCopy() {
    if (!curDoc) return;
    navigator.clipboard.writeText(curDoc.raw).then(function () {
        $('#btnCopy').html('<i class="fas fa-check"></i>');
        setTimeout(() => $('#btnCopy').html('<i class="far fa-copy"></i>'), 1200);
    });
}

/** 접혀 있는 폴더 안의 문서를 열었으면 그 길을 펴 준다 (링크·검색으로 건너뛴 경우) */
function openAncestors($item) {
    $item.parents('.aid-dir').each(function () {
        $(this).children('.aid-dir-body').show();
        $(this).children('.aid-dir-head').find('i').attr('class', 'fas fa-caret-down');
        delete folded[$(this).data('path')];
    });
    $j.Common.Store.local.setJSON(SK_FOLD, folded);
}

function scrollIntoNav($item) {
    const $box = $('#tree');
    const top  = $item.position().top + $box.scrollTop();
    if (top < $box.scrollTop() || top > $box.scrollTop() + $box.height() - 40) $box.scrollTop(top - 60);
}

/** 렌더된 본문에서 검색어를 칠한다. 텍스트 노드만 건드려 태그를 깨지 않는다 */
function highlight(root, q) {
    if (!root || !q) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const targets = [];
    const needle = q.toLowerCase();

    while (walker.nextNode()) {
        const n = walker.currentNode;
        if (n.parentNode.nodeName === 'SCRIPT') continue;
        if (n.nodeValue.toLowerCase().indexOf(needle) !== -1) targets.push(n);
    }
    targets.forEach(function (n) {
        const span = document.createElement('span');
        span.innerHTML = hl(esc(n.nodeValue), q);
        n.parentNode.replaceChild(span, n);
    });
}

function hl(escaped, q) {
    const re = new RegExp('(' + q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi');
    return escaped.replace(re, '<span class="aid-hl">$1</span>');
}

function esc(s) {
    return String(s === null || s === undefined ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

function cssEsc(s) { return String(s).replace(/(["\\])/g, '\\$1'); }
